<template>
	<div class="register-first-check-step">
        <div class="titles">
            <h3 class="login-form__title">
                {{ $t('register.accountRegis') }}
            </h3>

            <p class="linkRegistro" v-html="$t(textEntity)"></p>
        </div>

        <TVCheckboxSingle
            v-if="!isCountryEurope"
            id="check_regis"
            name="agreethree"
            v-model="checkRegistration"
            :label="$t('register.checkRegis')"
            class="check-switch-entities"
        />

        <div class="btn-check-container">
            <button
                class="red-button"
                @click="continueDisclaimer"
                :disabled="!isCountryEurope && !checkRegistration"
                style="max-width: none; width: 100%; margin-right: 0"
            >
                {{ $t('register.getstarted') }}
            </button>

            <button
                class="transparent-button"
                @click="backEntity"
                style="max-width: none; width: 100%"
            >
                {{ $t(textBtnAccountRegis) }}
            </button>
        </div>
    </div>
</template>

<script>
import { ref, computed } from 'vue'
import TVCheckboxSingle from '../../../modules/ui/TVCheckboxSingle.vue'

export default {
	name: 'Disclaimer Entity',
	emits: ['continueDisclaimer'],
	components: {
		TVCheckboxSingle
	},
    props: {
        textEntity: String,
        isCountryEurope: Boolean,
    },
	setup(props, { emit }) {
		let checkRegistration = ref(false)

        const textBtnAccountRegis = computed(() => {
			return props.isCountryEurope ? 'register.changeRegion' : 'register.goBack'
		})

        const continueDisclaimer = () => {
            emit('continueDisclaimer', {
                subStep: 2,
                checkRegistration: checkRegistration.value
            })
        }

        const backEntity = () => {
            if (props.isCountryEurope) {
                window.open('https://cabinet.tradeview.eu/register/1/live-account')
            }

            emit('continueDisclaimer', {
                subStep: 0,
                checkRegistration: false
            })
        }

		return {
			checkRegistration,
            continueDisclaimer,
            textBtnAccountRegis,
            backEntity
		}
	},
}
</script>
